export default "__VITE_ASSET__3e1a2a9e__"